export const isActiveNavSection = (href: string): boolean => {
  const pathname = global?.window?.location?.pathname;

  if (!pathname) {
    return false;
  }

  return pathname === href || pathname === `${href}/`;
};
